import { signOut } from '@lichtblick/auth';

import { savePendingLogoutRedirectUrl } from './redirectState';

import type { ApolloError } from '@lichtblick/apollo';

export const LogoutOnError = (error: ApolloError) => {
  if (error.networkError && 'statusCode' in error.networkError && error.networkError.statusCode === 401) {
    if (typeof window !== 'undefined') {
      const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;

      savePendingLogoutRedirectUrl(currentPath);
    }

    signOut();
  }
};
